export const getUnique = (arr) => {
  if (arr.length > 0) {
    const unique = [
      ...new Map(arr.map((item) => [item["_id"], item])).values(),
    ];
    return unique;
  }
  return [];
};
